import SectionHeader from './sectionHeader';
import PlanCardContainer from '../homePage/planCardContainer';
import { makeid } from '../../constants';
import cx from 'classnames';

const getData = (buckets: any) => {
  return buckets.map((bucket: number | string) =>
    require(`../../constants/fundBuckets/bucketData/bucket${bucket}.json`)
  );
};

const RecommendedPlans = ({ showTitle = true, funds }) => (
  <div className="recommended-block mb20">
    {showTitle ? (
      <SectionHeader title="Other Recommended Plans" golden />
    ) : null}
    <div className={cx(!showTitle ? 'mt30' : null, 'row small-blocks')}>
      {getData(funds).map((data: any) => (
        <div
          key={makeid()}
          className={cx(
            !showTitle ? 'large-4 columns' : null,
            'large-6 columns'
          )}
        >
          <PlanCardContainer data={data} />
        </div>
      ))}
    </div>
    <style jsx>{`
      .small-blocks {
        zoom: 0.9;
      }
      .small-blocks .large-4.columns {
        padding: 0 10px;
      }
      @media (max-width: 640px) {
        .small-blocks {
          zoom: 1.1;
        }
        .small-blocks .large-4.columns {
          padding-bottom: 10px;
        }
      }
    `}</style>
  </div>
);

export default RecommendedPlans;



// WEBPACK FOOTER //
// ./components/plan/recommendedPlans.tsx